MOVE.ARTICLE = (function (MOVE) {
  'use strict';

  var init = function () {
      MOVE.AutoComplete.init($("#searchBox"), null, false, {});
  };

  MOVE.ARTICLE =
  {
    init: init
  };

  return MOVE.ARTICLE;
})(MOVE || {});


// WEBPACK FOOTER //
// ./news_and_advice/news_and_advice.js